export type BaseMapType = 'WMS' | 'XYZ' | 'MAPBOX_STYLE';

export function validateBaseMapUrl(type: BaseMapType, url: string): string | null {
  if (!url.trim()) return 'URL is required';

  switch (type) {
    case 'XYZ':
      if (!url.includes('{x}') || !url.includes('{y}') || !url.includes('{z}')) {
        return 'XYZ URL must contain {x}, {y}, and {z} placeholders';
      }
      return null;
    case 'MAPBOX_STYLE':
      if (!url.startsWith('mapbox://styles/')) {
        return 'Mapbox style URL must start with mapbox://styles/';
      }
      return null;
    case 'WMS':
      try {
        new URL(url);
        return null;
      } catch {
        return 'Invalid WMS URL';
      }
  }
}
